import { FC } from 'react'

import { RadioGroup } from 'ui/components'
import { TextareaInput } from 'ui/components/InputV2'
import { Select } from 'ui/components/Select'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { MainText, SecondText } from '../../style'
import { ReviewTheApplicableStateCannabisProps } from './ReviewTheApplicableStateCannabisProps'

export const ReviewTheApplicableStateCannabis: FC<ReviewTheApplicableStateCannabisProps> = ({ Field }) => (
  <>
    <FormRow>
      <Col2x>
        <MainText>
          The business is unable to produce satisfactory documentation or evidence to demonstrate that it is duly
          licensed and operating consistently with state law.
          <br />
          The business, its owner(s), manager(s), or other related parties are, or have been, subject to an enforcement
          action by the state or local authorities responsible for administering or enforcing marijuana-related laws or
          regulations.
        </MainText>
      </Col2x>
    </FormRow>
    <FormRow>
      <Col>
        <SecondText>
          Review the state licensing website to check for business and owner license types which correspond with the
          most recent annual license review on file and have an “Active” status.
        </SecondText>
      </Col>
      <Col>
        <Field
          name="reviewTheApplicableStateCannabisRedFlag"
          input={RadioGroup}
          inputProps={{
            data: [
              {
                label: 'Yes',
                value: 'yes'
              },
              {
                label: 'No',
                value: 'no'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewTheApplicableStateCannabisChangeInBusinessLicensing"
          label="Was there a change in business or owner/signer licensing?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'No changes',
                value: 'no_changes'
              },
              {
                label: 'Business Licensing Change – See Comments',
                value: 'business_changes_in_licensing'
              },
              {
                label: 'Owner/Signer Licensing Change – See Comments',
                value: 'owner_changes_in_licensing'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col2x>
        <Field
          name="reviewTheApplicableStateCannabisComments"
          label="Comments"
          input={TextareaInput}
          inputProps={{
            maxLength: 5000
          }}
        />
      </Col2x>
    </FormRow>
  </>
)
